import type { Catalog } from "../../en";

export const evaluations: Catalog["build"]["evaluations"] = {
  title: "Mga evaluation",
  subtitle: "Ang mga test set ay mga tanong na may inaasahang sagot. Patakbuhin sila pagkatapos baguhin ang dokumento o settings para mahuli ang mga regression.",
  agent: "Agent",
  runAll: "Patakbuhin lahat",
  runAllQueued_one: "{{count}} run ang naka-queue",
  runAllQueued_other: "{{count}} run ang naka-queue",
  newSetButton: "Bagong test set",
  planFeature: "Evaluations",
  latest: {
    title: "Pinakabagong run",
    number: "#{{number}}",
    passed: "Pumasa sa threshold",
    failed: "Mas mababa sa threshold",
    running: "Tumatakbo",
    meta: "{{set}} · {{date}} · {{trigger}}",
    compare: "Ikumpara sa #{{number}}",
    export: "I-export",
    exported: "Na-export ang report: {{file}}",
    passRate: "Pass rate",
    vsPrevious: "{{value}} kaso kumpara sa run #{{number}}",
    pass: "{{count}} pasado",
    partial: "{{count}} bahagya",
    fail: "{{count}} bagsak",
    model: "Model",
    chunk: "Laki ng chunk",
    chunkValue: "{{value}} tokens",
    reranker: "Reranker",
    rerankerValue: "{{reranker}} · top-k {{k}}",
    judge: "Judge",
    duration: "Tagal",
    marker: "Marker = pass threshold ({{threshold}}). Kapag bumaba nang higit sa 0.05 ang anumang metric, aabisuhan sa email ang Owner at mga Admin.",
    noRuns: "Wala pang run",
    noRunsBody: "Magpatakbo ng test set para makita ang score kada metric at ang mga bumagsak na kaso.",
  },
  metrics: {
    faithfulness: "Faithfulness (grounded)",
    faithfulnessBody: "Bawat pahayag sa sagot ay suportado ng mga nakuhang dokumento.",
    answer_correctness: "Kawastuhan ng sagot",
    answer_correctnessBody: "Tugma ang sagot sa inaasahang sagot at sinasagot nito ang tanong.",
    context_precision: "Context precision",
    context_precisionBody: "May kaugnayan sa tanong ang mga nakuhang chunk.",
    context_recall: "Context recall",
    context_recallBody: "Nakita ang inaasahang source sa mga nakuhang chunk.",
    citation_accuracy: "Kawastuhan ng citation",
    citation_accuracyBody: "Tumuturo ang citation sa page na talagang may impormasyon.",
    refusal_correctness: "Tamang pagtanggi",
    refusal_correctnessBody: "Sinasabing “Hindi ko alam” o nagpapasa kapag walang sagot ang mga dokumento.",
    threshold: "Threshold {{value}}",
    noScore: "—",
  },
  sets: {
    title: "Mga test set",
    summary: "{{sets}} set · {{cases}} kaso · ginagamit ng mga naka-schedule na run ang live settings ng agent",
    filter: "I-filter ang mga test set…",
    filterLabel: "I-filter ang mga test set",
    name: "Test set",
    agent: "Agent",
    schedule: "Schedule",
    lastRun: "Huling run",
    score: "Score",
    status: "Status",
    run: "Patakbuhin",
    runLabel: "Patakbuhin ang {{name}}",
    allAgents: "Lahat ng agent",
    cases_one: "{{count}} kaso",
    cases_other: "{{count}} kaso",
    origins: { manual: "idinagdag nang mano-mano", csv: "CSV upload", ai_generated: "gawa ng AI", conversations: "mula sa totoong usapan" },
    schedules: { manual: "Mano-mano", nightly: "Gabi-gabi 2:00 AM", on_knowledge_change: "Pagkatapos magbago ang knowledge" },
    health: { passing: "Pumapasa", failing: "Bumabagsak", stale: "Luma na · nagbago ang knowledge", never_run: "Hindi pa napapatakbo" },
    never: "Hindi pa",
    progress: "Tumatakbo…",
    queued: "Naka-queue ang run · {{name}}",
    empty: "Wala pang test set",
    emptyBody: "Gumawa ng test set mula sa CSV o hayaang mag-draft ang AI ng mga tanong mula sa iyong mga dokumento.",
    noMatch: "Walang test set na tugma sa filter",
    open: "Buksan ang {{name}}",
  },
  history: {
    title: "Kasaysayan ng run",
    subtitle: "{{set}} · ikumpara ang mga configuration para makita kung ano ang talagang nagpabuti sa mga sagot",
    all: "Lahat ng run",
    configOnly: "Mga pagbabago sa config lang",
    run: "Run",
    when: "Kailan",
    trigger: "Trigger",
    model: "Model",
    chunk: "Laki ng chunk",
    reranker: "Reranker",
    score: "Score",
    pass: "Pasado",
    latest: "Pinakabago",
    compare: "Ikumpara",
    compareLabel: "Ikumpara ang run #{{a}} sa #{{b}}",
    on: "On",
    off: "Off",
    empty: "Wala pang run para sa test set na ito",
    triggers: { manual: "Mano-mano", nightly: "Gabi-gabi", knowledge_change: "Pagbabago ng knowledge" },
  },
  compare: {
    title: "Run #{{a}} laban sa run #{{b}}",
    setting: "Setting",
    change: "Pagbabago",
    changed: "Nagbago",
    same: "Pareho",
    scores: "Mga score",
    overall: "Kabuuang score",
    passRate: "Pass rate",
    sameCases: "Parehong mga kaso, parehong judge model.",
    differentCases: "Nagbago ang mga kaso sa pagitan ng mga run na ito — mag-ingat sa pagkumpara.",
    useNewer: "Gamitin ang mas bagong config",
    nothingToApply: "Walang setting sa run na ito na mailalapat sa agent.",
    applied: "Nailapat sa {{name}} ang settings ng run #{{number}}",
    close: "Isara",
  },
  failed: {
    title: "Mga bumagsak na kaso sa run #{{number}}",
    subtitle: "{{fail}} bagsak · {{partial}} bahagya · buksan ang kaso para makita kung ano ang nakuha ng agent at bakit ganito ang marka ng judge",
    none: "Walang bumagsak na kaso sa run na ito",
    expected: "Inaasahang sagot",
    actual: "Aktuwal na sagot",
    retrieved: "Mga nakuhang source",
    reasoning: "Paliwanag ng judge",
    noReasoning: "Walang paliwanag ang judge para sa kasong ito.",
    noAnswer: "Walang naitalang sagot.",
    verdicts: { fail: "Bagsak", partial: "Bahagya", pass: "Pasado" },
    fixSource: "Suriin ang source",
    fixKnowledge: "Buksan ang Knowledge Base",
    fixInstructions: "I-edit ang mga tagubilin",
    accept: "Markahang katanggap-tanggap",
    accepted: "Minarkahang katanggap-tanggap. Na-update ang inaasahang sagot.",
    acceptedBadge: "Tinanggap",
    source: "Source",
  },
  setSheet: {
    cases: "Mga kaso",
    addCase: "Magdagdag ng kaso",
    question: "Tanong",
    expectedAnswer: "Inaasahang sagot",
    expectedSource: "Inaasahang source",
    saveCase: "I-save ang kaso",
    caseAdded: "Naidagdag ang kaso",
    deleteCase: "Burahin ang kaso",
    caseDeleted: "Nabura ang kaso",
    noCases: "Wala pang kaso — mag-import ng CSV o gumawa ng mga tanong.",
    loadMore: "Mag-load pa",
    schedule: "Schedule",
    alert: "I-email ang Owner at mga Admin kapag bumaba nang higit sa 0.05 ang anumang score",
    saveSchedule: "I-save ang schedule",
    scheduleSaved: "Na-save ang schedule",
    import: "Mag-import ng CSV",
    generate: "Gumawa gamit ang AI",
    deleteSet: "Burahin ang test set",
    deleteTitle: "Burahin ang {{name}}?",
    deleteBody: "Mabubura ang mga kaso at kasaysayan ng run nito. Hindi na ito maibabalik.",
    deleteConfirm: "I-type ang pangalan ng test set para kumpirmahin",
    deleted: "Nabura ang test set",
    questionRequired: "Maglagay ng tanong.",
  },
  csv: {
    label: "Mag-upload ng CSV",
    paste: "O i-paste ang CSV",
    columns: "question, expected_answer, expected_source",
    template: "I-download ang CSV template",
    preview: "Suriin ang file",
    summary: "{{rows}} row · {{columns}} column ang natukoy",
    valid: "Wasto",
    invalid: "Kailangang ayusin",
    errors: "Mga problema",
    importButton: "Mag-import ng {{count}} kaso",
    imported_one: "{{count}} kaso ang na-import",
    imported_other: "{{count}} kaso ang na-import",
    tooLarge: "Mas malaki sa 512 KB ang CSV.",
    dropzone: {
      title: "I-click para pumili ng CSV, o i-drop dito",
      hint: "CSV · hanggang 512 KB",
      browse: "Pumili ng file",
    },
  },
  generate: {
    title: "Gumawa mula sa mga dokumento gamit ang AI",
    body: "Gagawa kami ng mga tanong at inaasahang sagot mula sa iyong mga source. Suriin ang mga ito bago ang unang run.",
    documents: "Mga dokumentong pagmumulan",
    noDocuments: "Walang available na dokumento — magdagdag muna ng knowledge.",
    count: "Bilang ng tanong",
    taglish: "Isama ang mga bersyong Taglish",
    refusals: "Magdagdag ng mga tanong na dapat tanggihan",
    multiStep: "Mga tanong na maraming hakbang",
    options: "Mga opsyon sa tanong",
    submit: "Gumawa ng mga tanong",
    generated_one: "{{count}} tanong ang nagawa",
    generated_other: "{{count}} tanong ang nagawa",
  },
  newSet: {
    title: "Bagong test set",
    name: "Pangalan",
    namePlaceholder: "hal. Mga tanong tungkol sa presyo",
    nameRequired: "Maglagay ng pangalan.",
    agent: "Agent",
    aiSwitch: "Gumawa mula sa mga dokumento gamit ang AI",
    schedule: "Schedule",
    manual: "Mano-mano lang",
    manualBody: "Tatakbo kapag pinindot mo ang Patakbuhin",
    nightly: "Gabi-gabi",
    nightlyBody: "2:00 AM, {{timezone}}",
    onChange: "Pagkatapos ng bawat pagbabago sa knowledge",
    onChangeBody: "Upload, edit o re-sync",
    submit: "Gumawa ng test set",
    created: "Nagawa ang test set. Naka-queue ang unang run.",
    createdNoRun: "Nagawa ang test set.",
    csvRequired: "Magdagdag ng CSV na may kahit isang wastong row, o i-on ang paggawa gamit ang AI.",
  },
};
